import {
  AncillaryFetchOfferFailure,
  AncillaryFetchOfferRequest,
  AncillaryFetchOfferResponse,
  AncillaryFetchOfferResponseEnum,
  AncillaryFetchOfferSuccess,
  AncillaryKindEnum,
  AncillaryOfferEnum,
  CfarOffer,
} from "redmond";
import { call, put, select } from "redux-saga/effects";
import { actions } from "../../actions";
import Logger from "../../../../helpers/Logger";
import { getAncillaryOffer } from "../../../../api/v2/ancillary/getAncillaryOffer";
import { fetchAncillaryOfferRequestParametersSelector } from "../../../shop/reducer/selectors";

export function* fetchCfarPostBookingOfferSaga(
  action: actions.IFetchCfarPostBookingOffer,
) {
  try {
    const shopRequest: AncillaryFetchOfferRequest | null = yield select(
      fetchAncillaryOfferRequestParametersSelector,
    );

    const fetchOfferRequest = action.fetchOfferRequest ?? shopRequest;

    if (!fetchOfferRequest) {
      yield put(actions.resetCfarPostBookingOfferState());
      return;
    }

    const response: AncillaryFetchOfferResponse = yield call(
      getAncillaryOffer,
      {
        ...fetchOfferRequest,
        itineraryId: action.itineraryId,
        pnr: action.pnr,
        requestedProducts: [AncillaryKindEnum.Cfar],
      },
    );

    const responseFailure = response as AncillaryFetchOfferFailure;
    if (responseFailure.Failure) {
      yield put(actions.resetCfarPostBookingOfferState());
      return;
    }

    const responseSuccess = response as AncillaryFetchOfferSuccess;
    switch (responseSuccess.FetchOfferResponseV2) {
      case AncillaryFetchOfferResponseEnum.MultiTicketV2:
      case AncillaryFetchOfferResponseEnum.SingleTicket:
      case AncillaryFetchOfferResponseEnum.MultiCity:
        break;
      default:
        yield put(actions.resetCfarPostBookingOfferState());
        return;
    }

    const cfarOffer = responseSuccess.ancillaryOffers.find(
      (offer) => offer.AncillaryOffer === AncillaryOfferEnum.CfarOffer,
    ) as CfarOffer | undefined;

    if (cfarOffer?.merchandisingUrl) {
      yield put(
        actions.setCfarPostBookingOfferResponse(cfarOffer, fetchOfferRequest),
      );
    } else {
      yield put(actions.resetCfarPostBookingOfferState());
    }
  } catch (e) {
    yield put(actions.resetCfarPostBookingOfferState());
    Logger.debug(e);
  }
}
